/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {

    init: function() {
      const _this = this;
      let elementID = 0;
      const initialEnemyGenerationSpeed = 1400;
      let enemyGenerationSpeed = initialEnemyGenerationSpeed;
      const laserSound = new Audio( '/wp-content/themes/liftedlogic/assets/sounds/game/laser.wav' );
      laserSound.volume = 0.3;
      const hitSound = new Audio( '/wp-content/themes/liftedlogic/assets/sounds/game/ow.wav' );
      const gameOverSound = new Audio( '/wp-content/themes/liftedlogic/assets/sounds/game/death.wav' );
      const powerupSound = new Audio( '/wp-content/themes/liftedlogic/assets/sounds/game/powerup.wav' );
      const music = new Audio( '/wp-content/themes/liftedlogic/assets/sounds/game/chrome-zone.mp3' );
      music.volume = 0.3;
      // Music needs to be credited
      console.log( 'Music: Chrome Zone by Shane Ivers - https://www.silvermansound.com' );
      let hitBox = 0;
      let gameOver = false;
      let muted = false;
      let musicPause = false;
      let powerUp = '';
      const enemySVG = '<svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_470:13847)"> <path d="M10.2519 15.3499L10.2519 19.5978C10.2519 21.0033 11.3952 22.1466 12.8007 22.1466L13.1251 22.1466L12.2755 23.8458L7.70311 23.8458C7.23351 23.8458 6.85352 24.2258 6.85352 24.6954C6.85352 25.165 7.23351 25.545 7.70311 25.545L12.8007 25.545C13.1226 25.545 13.4163 25.3633 13.5606 25.0754L15.025 22.1466L17.1053 22.1466L17.1053 26.3945C17.1053 26.8641 17.4853 27.2441 17.9548 27.2441C18.4244 27.2441 18.8044 26.8641 18.8044 26.3945L18.8044 22.1466L20.8281 22.1466L22.2924 25.0754C22.4368 25.3633 22.7305 25.545 23.0524 25.545L28.15 25.545C28.6196 25.545 28.9995 25.165 28.9995 24.6954C28.9995 24.2258 28.6196 23.8458 28.15 23.8458L23.5776 23.8458L22.6569 22.0045C24.3555 21.7038 25.8638 20.8583 26.9826 19.6318L22.7006 15.3498L10.2519 15.3498L10.2519 15.3499Z"/> <path d="M27.9858 10.7689L24.2539 14.5008L27.9858 18.2327C28.6123 17.124 28.9997 15.8627 28.9997 14.5008C28.9997 13.139 28.6123 11.8776 27.9858 10.7689Z"/> <path d="M18.8044 2.60558C18.8044 2.13598 18.4244 1.75598 17.9548 1.75598C17.4852 1.75598 17.1052 2.13598 17.1052 2.60558L17.1052 6.85353L15.025 6.85353L13.5606 3.92477C13.4163 3.63687 13.1226 3.45517 12.8006 3.45517L7.70311 3.45517C7.23351 3.45517 6.85352 3.83516 6.85352 4.30476C6.85352 4.77436 7.23351 5.15435 7.70311 5.15435L12.2755 5.15435L13.1251 6.85353L12.8006 6.85353C11.3952 6.85353 10.2519 7.99686 10.2519 9.40231L10.2519 13.6503L22.7006 13.6503L26.9826 9.36827C25.8638 8.1418 24.3555 7.29623 22.657 6.99559L23.5776 5.1543L28.15 5.1543C28.6196 5.1543 28.9996 4.7743 28.9996 4.3047C28.9996 3.83511 28.6196 3.45511 28.15 3.45511L23.0524 3.45511C22.7305 3.45511 22.4368 3.63681 22.2924 3.92471L20.8281 6.85348L18.8045 6.85348L18.8045 2.60558L18.8044 2.60558Z"/> <path d="M8.55322 20.4478L8.55322 8.55354C6.6763 8.55354 5.09821 10.075 5.09821 11.9519C4.71272 11.9519 4.35097 12.0439 4.02337 12.1971L1.3215 10.3955C0.931533 10.1349 0.40388 10.2403 0.143339 10.6311C-0.117995 11.0235 -0.0117965 11.5503 0.378959 11.8092L2.79695 13.4216C2.64244 13.7503 2.54938 14.1134 2.54938 14.5007C2.54938 14.8879 2.64238 15.251 2.79695 15.5798L0.379016 17.1922C-0.0117395 17.4527 -0.117938 17.9812 0.143396 18.3703C0.403937 18.7611 0.93159 18.8665 1.32155 18.606L4.02342 16.8043C4.35102 16.9575 4.71278 17.0495 5.09827 17.0495C5.09821 18.9263 6.6763 20.4478 8.55322 20.4478Z" fill="#443E51"/> </g> <defs> <clipPath id="clip0_470:13847"> <rect width="29" height="29" fill="white" transform="translate(0 29) rotate(-90)"/> </clipPath> </defs> </svg>';

      // Stop current sound, restart it, play it
      function playSound( sound ) {
        if ( !muted ) {
          sound.pause();
          sound.currentTime = 0;
          sound.play();
        }
      }

      // Mute game
      $( document ).on( 'click', '.sound-mode', function() {
        $( this ).toggleClass( 'volume-off' );
        muted = muted ? false : true;
        if ( muted ) {
          music.pause();
        } else {
          if ( !musicPause ) {
            music.play();
          }
        }
      } );

      // Mute the music
      $( document ).on( 'click', '.music-mode', function() {
        $( this ).toggleClass( 'music-off' );
        musicPause = musicPause ? false : true;
        if ( musicPause ) {
          music.pause();
        } else {
          music.play();
        }
      } );

      // Tests for konami code for power ups
      const konami = 'uuddlrlrba';
      let konamiTest = '';
      $( document ).keydown( function( e ) {
        const shipTop = parseInt( $( '.ship' ).css( 'top' ).replace( 'px', '' ) );
        switch ( e.which ) {
          case 38: // up
            konamiTest += 'u';
            break;

          case 40: // down
            konamiTest += 'd';
            break;

          case 37: // left
            konamiTest += 'l';
            break;

          case 39: // right
            konamiTest += 'r';
            break;

          case 65: // a
            konamiTest += 'a';
            break;

          case 66: // b
            konamiTest += 'b';
            break;

          default: return;
        }
        e.preventDefault();
        testKonami();
      } );

      // Continuing the konami code test
      function testKonami() {
        if ( konamiTest.length > 0 && konami.indexOf( konamiTest ) == -1 ) {
          konamiTest = '';
        }

        if ( konamiTest == konami ) {
          konamiTest = '';
          playSound( powerupSound );
          // enemyGenerationSpeed = 100000;
          const powerupGenerator = Math.floor( ( Math.random() * 2 ) + 1 );

          if ( powerupGenerator == 1 ) {
            clearInterval( laserTimer );
            powerUp = 'powered-up';
            hitBox = 50;
          } else if ( powerupGenerator == 2 ) {
            clearInterval( laserTimer );
            powerUp = 'rapid-fire';
            laserTimer = setInterval( addLaser, 100 );
          }
        }
      }

      // Add the lasers
      let laserNum = 1;
      let laserTimer;
      $( document ).on( 'click', '.game-area', function( e ) {
        addLaser();
      } );

      function addLaser() {
        if ( !gameOver ) {
          playSound( laserSound );
          $( '.game' ).append( '<div class="laser laser-' + laserNum + ' ' + powerUp + '" id="laser-' + elementID + '"></div>' );
          $( '#laser-' + elementID ).css( {
            top: $( '.ship' ).position().top + ( $( '.ship' ).outerHeight() / 2.2 ),
            left: $( '.ship' ).position().left + $( '.ship' ).width(),
          } );
          elementID++;
          if ( laserNum < 4 ) {
            laserNum++;
          } else {
            laserNum = 1;
          }
        }
      }

      // add enemies
      function addEnemies() {
        if ( !gameOver ) {
          const enemyTop = Math.floor( ( Math.random() * 100 ) + 1 );

          $( '.game' ).append( '<div class="enemy" id="enemy-' + elementID + '">' + enemySVG + '</div>' );
          $( '#enemy-' + elementID ).css( {
            top: Math.floor( ( Math.random() * 85 ) + 10 ) + '%',
            right: '-10px',
          } );
          elementID++;
        }
      }

      // Set up enemy timer
      let enemyTimer;

      // Collision watching
      setInterval( function() {
        $( '.laser' ).each( function( laserKey, laserVal ) {
          $( '.enemy' ).each( function( enemyKey, enemyVal ) {
            // if laser collides with enemy
            if (
              $( laserVal ).position().left >= $( enemyVal ).position().left &&
              (
                $( laserVal ).position().top >= $( enemyVal ).position().top - hitBox &&
                $( laserVal ).position().top <= $( enemyVal ).position().top + $( enemyVal ).outerHeight() + hitBox
              )
            ) {
              $( laserVal ).remove();
              $( enemyVal ).remove();
              playSound( hitSound );
              const score = parseInt( $( '.score' ).text() );
              $( '.score' ).text( score + 100 );

              // if the enemeryGenerationSpeed is more than 140,
              // speed it up a bit more. do not go below 140 or else
              // it will literally be impossible and your computer will
              // catch fire
              if ( enemyGenerationSpeed > 140 ) {
                // enemyGenerationSpeed -= 20;
                if ( enemyGenerationSpeed > 500 ) {
                  enemyGenerationSpeed = enemyGenerationSpeed - ( enemyGenerationSpeed * .05 );
                } else {
                  enemyGenerationSpeed = enemyGenerationSpeed - ( enemyGenerationSpeed * .01 );
                }
                clearInterval( enemyTimer );
                enemyTimer = setInterval( addEnemies, enemyGenerationSpeed );
              } else {
                console.log( 'Good luck. We\'re all counting on you.' );
              }
            }
          } );

          // if the laser goes off screen, remove it
          if ( $( laserVal ).position().left > $( '.game' ).width() ) {
            $( laserVal ).remove();
          }
        } );

        // Check for enemy going off screen, causing game over
        $( '.enemy' ).each( function( enemyKey, enemyVal ) {
          if ( $( enemyVal ).position().left <= 0 && !gameOver ) {
            $( enemyVal ).remove();
            playSound( gameOverSound );
            $( '.game-over' ).addClass( 'show' );
            $( '.ship' ).hide();
            gameOver = true;
            clearInterval( enemyTimer );
            enemyGenerationSpeed = 100000;
            enemyTimer = setInterval( addEnemies, enemyGenerationSpeed );
          }

          // Remove each enemy after 10s
          setTimeout( function() {
            $( enemyVal ).remove();
          }, 10000 );
        } );
      }, 1 );

      $( '.game' ).mousemove( function( e ) {
        const relPos = e.pageY - $( this ).offset().top;
        $( '.ship' ).css( 'top', relPos - ( $( '.ship' ).outerHeight() / 2 ) );
      } );

      // Start the game
      $( '.start-game' ).click( function() {
        $( '.error-page' ).fadeOut();
        $( '.game-area' ).fadeIn();
        $( '.instructions' ).addClass( 'show' );
        music.play();
        music.addEventListener( 'ended', function() {
          this.currentTime = 0;
          this.play();
        }, false );
        setTimeout( function() {
          $( '.instructions' ).removeClass( 'show' );
        }, 4000 );

        // Start up enemy timer
        enemyTimer = setInterval( function() {
          addEnemies();
        }, enemyGenerationSpeed );
      } );

      // Restart the game, revert all settings back to defaults
      $( document ).on( 'click', '.game-over .restart', function() {
        gameOver = false;
        enemyGenerationSpeed = initialEnemyGenerationSpeed;
        clearInterval( laserTimer );
        clearInterval( enemyTimer );
        enemyTimer = setInterval( addEnemies, enemyGenerationSpeed );
        score = 0;
        hitBox = 0;
        powerUp = '';
        $( '.game-over' ).removeClass( 'show' );
        $( '.ship' ).show();
        $( '.enemy' ).remove();
        $( '.score' ).text( 0 );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'error', COMPONENT );
} )( app );
